<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.21</b> - TWO ability points per level now? ~ whaaaaaat ...
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>You heard that right. Heroes now get not 1 but 2 ability points per level.</li>
      <li>
        Suture potency increased:
        <code>20 + L*(Le/6 + De/4)</code> -->
        <code>20 + L*(Le + De)</code>
      </li>
      <li>
        Poison Weapon AP cost decreased:
        <code>50 - L</code> -->
        <code>30 - L</code>
      </li>
      <li>
        When traveling in Caverns, any friendly dwarves in play will now start out in
        front.
      </li>
      <li>
        Fixed several Caverns battle log bugs, like null/undefined unit names, and keeping
        your position while scrolling.
      </li>
      <li>
        Limited the number of initial caverns mobs to 1~5, to avoid overwhelming heroes
        before they've had a chance to buff/summon.
      </li>
    </ul>
  </div>
</template>
